import { Pipe, PipeTransform } from '@angular/core';
import { GeneralService } from 'src/app/shared/services/general.service';

@Pipe({ name: 'getTag' })
export class PipeGetTag implements PipeTransform {
   constructor(private gs: GeneralService) {

   }
   transform(id = false, area: string, column: any = 'tag') {
        return this.gs.getTags(area, false, id, column);
   }
}